import {LeanDocument, Types} from 'mongoose';
import {API} from './api.class';
import {FindByIdOptionsRequestDto} from '@/classes/dto/_common/request/FindByIdOptions.request.dto';
import {CreateTaxonomyEntryRequestDto} from '@/classes/dto/taxonomy-manager/request/CreateTaxonomyEntry.request.dto';
import {CrudEntityTypes} from '@/classes/clientOnly/permissionTreeResources/enums/CrudEntityTypes';
import {TaxonomyEntryDocument} from '@/documentTypes/taxonomy-manager/TaxonomyEntry.document';
import {FindTaxonomyEntryRequestDto} from '@/classes/dto/taxonomy-manager/request/FindTaxonomyEntry.request.dto';
import {UpdateTaxonomyEntryRequestDto} from '@/classes/dto/taxonomy-manager/request/UpdateTaxonomyEntry.request.dto';
import {PaginationResponseType} from '@/types/common/paginationResponseType';

/**
 * This class is used for communicating with TaxonomyManager microservice
 * @class TaxonomyManagerApi
 * @author mklaczinski
 */
export class TaxonomyManagerApi extends API {
    static service = 'taxonomy-manager';

    static async create(newDocument: CreateTaxonomyEntryRequestDto): Promise<Types.ObjectId> {
        return this.post(``, newDocument);
    }

    static async update(id: Types.ObjectId, update: UpdateTaxonomyEntryRequestDto): Promise<Types.ObjectId> {
        return this.put(`${id}`, update);
    }

    /** Saves the order of a taxonomy: ids in the wanted order */
    static async reorder(data: { taxonomy: string; ids: Array<Types.ObjectId | string> }): Promise<{ updated: number }> {
        return this.put('reorder', data);
    }

    static async find(findQuery: FindTaxonomyEntryRequestDto): Promise<PaginationResponseType<CrudEntityTypes.TAXONOMY_ENTRY, TaxonomyEntryDocument>> {
        return this.get(``, findQuery);
    }

    static async findById(id: Types.ObjectId, options?: FindByIdOptionsRequestDto): Promise<LeanDocument<TaxonomyEntryDocument>> {
        return this.get(`${id}`, options);
    }

    static async remove(id: Types.ObjectId): Promise<Types.ObjectId> {
        return this.delete(`${id}`);
    }

}
